export const RECEIPT_BUSINESS_SLICE_NAME = "receiptBusiness"
